export default __webpack_public_path__ + "static/discord-0195c82d4a2dde0db67b2658fc93d1ab.svg";